import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxEchartsModule } from 'ngx-echarts';
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  LOCALE_ID,
  NgModule,
} from '@angular/core';
import {
  LocationStrategy,
  PathLocationStrategy,
  registerLocaleData,
} from '@angular/common';
import {
  HttpClientModule,
  HttpClientXsrfModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { ThemeModule } from './theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { FormsModule } from '@angular/forms';
import {
  NbAccordionModule,
  NbLayoutModule,
  NbIconModule,
  NbCardModule,
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbSpinnerModule,
  NbButtonModule,
} from '@nebular/theme';
import { DataTablesModule } from 'angular-datatables';
import { LoaderService } from './services/loader.service';

export interface NbAuthSocialLink {
  link?: string;
  url?: string;
  target?: string;
  title?: string;
  icon?: string;
}

const socialLinks: NbAuthSocialLink[] = [];

const formSetting: any = {
  redirectDelay: 0,
  showMessages: {
    success: true,
  },
};

import localeId from '@angular/common/locales/id';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { HeaderInterceptor } from './services/header.interceptor';
import { ErrorInterceptor } from './services/error.inteceptor';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';
import { PreviewDialogComponent } from './shared/preview-dialog/preview-dialog.component';

// HANYA IMPORT INI DARI angular-oauth2-oidc
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { SecureOAuthStorage } from './providers/secure-storage.provider';
import { SsoWebLoginComponent } from './sso-web-login/sso-web-login.component';
import { EnvService } from './services/env.service';

export function initEnvFactory(envService: EnvService) {
  return () => envService.resolveEnv();
}

registerLocaleData(localeId);

@NgModule({
  declarations: [AppComponent, PreviewDialogComponent, SsoWebLoginComponent],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'XSRF-TOKEN',
      headerName: 'X-XSRF-TOKEN',
    }),
    AppRoutingModule,
    NbEvaIconsModule,
    NgSelectModule,
    NbAccordionModule,
    NbIconModule,
    ThemeModule,
    NbLayoutModule,
    DataTablesModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbCardModule,
    NbButtonModule,
    NbSpinnerModule,
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    ToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    FormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
  ],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: LOCALE_ID, useValue: 'id' },
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initEnvFactory,
      deps: [EnvService],
      multi: true,
    },
    Diagnostic,

    provideOAuthClient(),

    { provide: OAuthStorage, useExisting: SecureOAuthStorage },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
